module.exports = __webpack_public_path__ + "img/head-side-mask.33cf2cd8.svg";